import {
  SET_CONVERSATION_ID_REAMS,
  SET_INITIAL_MESSAGE_REAMS,
  UPDATE_REAMS,
} from '../actions/types';

const initialState = {
  reamsMasterMap: undefined,
  isAddNewPropertyPanelActive: false,
  isAddNewPropertyMapActive: false,
  isChartFiltersPanelActive: false,
  selectedActiveSearchPlace: {},
  propertyChartFilters: {},
  selectedServiceCategoryFilters: [],
  trialLimitAlert: null,
  selectedDataset: ['ownLocation', 'sharepoint'],
  conversationId: null,
  initialMessage: null,
};

const reamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_REAMS:
      return { ...state, ...action.payload };

    case SET_CONVERSATION_ID_REAMS:
      return { ...state, conversationId: action.payload };

    case SET_INITIAL_MESSAGE_REAMS:
      return { ...state, initialMessage: action.payload };

    default:
      return state;
  }
};

export default reamsReducer;
